<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ $t(this.$route.name) }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">{{ $t('Home') }}</router-link>
              </li>
              <li class="breadcrumb-item active">
                <i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="row col-lg-12">
        <div class="col-lg-10 col-md-10 col-sm-10">
          <multiselect
            id="filter-videos"
            v-model="showVideos"
            :options="videos"
            :close-on-select="false"
            track-by="id"
            label="name"
            :multiple="true"
            placeholder="Select videos"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
          ></multiselect>
        </div>
      </div>
      <div class="container-fluid mt-2">
        <div class="row col-lg-12">
          <template v-for="video in showVideos2">
            <div
              class="col-lg-4 col-md-4 col-sm-12 mb-2"
              v-if="video.streams"
              :key="video.tableId"
            >
              <div
                class="video-item embed-responsive embed-responsive-16by9"
                @click.stop="playSwitch(video.id)"
                v-if="video.play === false"
              >
                <span>{{ video.name }}</span>
                <span>{{ video.tableId }}</span>
                <span class="play-btn"></span>
              </div>

              <template class="thumb" v-else>
                <div class="video-item embed-responsive embed-responsive-16by9">
                  <span class="video-title">{{ video.name }}</span>
                  <iframe
                    id="ifvideo"
                    width="100%"
                    height="100%"
                    scrolling="no"
                    frameborder="0"
                    allowfullscreen=""
                    :src="`${streamUrl(video)}`"
                  >
                  </iframe>
                </div>
              </template>
            </div>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getRouteIcon, ROUTE_LIVE_VIDEOS } from '../../utils/routerIcons'

import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  data() {
    return {
      videos: [],
      showVideos: [],
      showVideos2: [],
      sessionKeepAliveTimer: null,
      sessionStartTime: null,
      maxSessionDuration: 24 * 60 * 60 * 1000 // 24 часа в миллисекундах
    }
  },
  beforeMount() {
    console.log('VideoMonitoring component beforeMount')
    this.loadItems()
    this.startSessionKeepAlive()
  },
  beforeDestroy() {
    this.stopSessionKeepAlive()
  },
  methods: {
    isWowzaVideo(video) {
      return ['wowza', 'wowza-webrtc'].includes(video.vendor)
    },
    playSwitch(id) {
      const video = this.videos.find(v => v.id === id)
      video.play = !video.play
    },
    async loadItems() {
      let loadingInstance = this.$veLoading({
        target: document.querySelector('#loading-container'),
        name: 'wave'
      })
      this.videos = []
      // loadingInstance.show();

      this.$http({
        url: '/api/v1/streams',
        method: 'GET'
      })
        .then(resp => {
          resp.data.items.forEach(item => (item.play = true))
          this.videos = resp.data.items
        })
        .catch(err => {
          console.log(err)
          this.videos = []
          this.showError = true
        })
        .finally(() => {
          loadingInstance.close()
          this.cancel = null
        })
    },
    async getTokenVideo(tableId) {
      return await this.$http({
        baseURL: process.env.VUE_APP_BACK_URL,
        url: '/croupier/admin-video-secure/' + tableId,
        method: 'POST',
        data: {
          apiKey: process.env.VUE_APP_CHAT_API_KEY
        }
      })
        .then(async resp => {
          return resp.data.jwt
        })
        .catch(err => {
          console.log(err)
          return null
        })
    },
    startSessionKeepAlive() {
      console.log('Starting session keep-alive timer')
      // Записываем время начала сессии
      this.sessionStartTime = Date.now()

      // Запускаем таймер который каждые 5 минут делает API запрос для продления сессии
      this.sessionKeepAliveTimer = setInterval(async () => {
        const currentTime = Date.now()
        const elapsedTime = currentTime - this.sessionStartTime

        console.log(
          'Session keep-alive timer triggered. Elapsed time:',
          Math.round(elapsedTime / 1000 / 60),
          'minutes'
        )

        // Проверяем, не прошло ли уже 24 часа
        if (elapsedTime >= this.maxSessionDuration) {
          console.log(
            'Video monitoring session reached 24-hour limit, stopping keep-alive'
          )
          this.stopSessionKeepAlive()
          return
        }

        // Продлеваем сессию через refresh token
        console.log('Refreshing token to keep session alive...')
        const refreshed = await this.refreshToken()

        if (refreshed) {
          console.log('Session successfully extended via token refresh')
        } else {
          console.log('Failed to refresh token - session may expire soon')
        }
      }, 5 * 60 * 1000) // 5 минут в миллисекундах

      console.log(
        'Session keep-alive timer started with ID:',
        this.sessionKeepAliveTimer
      )
    },
    stopSessionKeepAlive() {
      console.log('Stopping session keep-alive timer')
      if (this.sessionKeepAliveTimer) {
        clearInterval(this.sessionKeepAliveTimer)
        this.sessionKeepAliveTimer = null
        console.log('Session keep-alive timer stopped')
      } else {
        console.log('No timer to stop')
      }
    },
    async refreshToken() {
      const refreshToken = localStorage.getItem('refreshToken')
      const username = localStorage.getItem('username')

      console.log('Attempting refresh with:', { refreshToken, username })

      if (!refreshToken || !username || refreshToken === 'null') {
        console.log('No valid refresh token available')
        return false
      }

      try {
        const response = await this.$http.post('/api/v1/token/refresh', {
          refreshToken: refreshToken,
          username: username
        })

        const newToken = response.data.token
        const newRefreshToken = response.data.refreshToken || refreshToken

        localStorage.setItem('token', newToken)
        localStorage.setItem('refreshToken', newRefreshToken)

        this.$http.defaults.headers.common['Authorization'] =
          'Bearer ' + newToken

        console.log('Token refreshed successfully in VideoMonitoring')
        return true
      } catch (error) {
        console.log('Failed to refresh token in VideoMonitoring:', error)
        return false
      }
    }
  },
  watch: {
    showVideos: {
      async handler(val) {
        await Promise.all(
          val.map(async video => {
            if (
              !this.isWowzaVideo(video) &&
              !this.showVideos2.find(v => v.tableId === video.tableId)
            ) {
              video.token = await this.getTokenVideo(video.tableId)
            }
          })
        )

        this.showVideos2 = val.map(video => ({
          play: video.play,
          streams: video.streams,
          tableId: video.tableId,
          id: video.id,
          name: video.name,
          closed: video.closed,
          vendor: video.vendor,
          token: video.token
        }))
      },
      deep: true
    }
  },
  computed: {
    streamUrl() {
      return video => {
        // Приоритет потоков: monitorStream -> lo -> dm -> hi
        const stream =
          video.streams.monitorStream ||
          video.streams.lo ||
          video.streams.dm ||
          video.streams.hi
        const wowza = this.isWowzaVideo(video)
        const params = new URLSearchParams({
          vendor: wowza ? 'wowza' : 'nano',
          stream
        })

        if (!wowza) {
          params.set('quality', 'High')
          if (video.token) params.set('jwt', video.token)
        }

        return `${process.env.VUE_APP_RTC_API_URL.replace(/\/$/, '')}/?${params}`
      }
    },
    ...mapGetters([]),
    routeIcon: () => getRouteIcon(ROUTE_LIVE_VIDEOS)
  },

  name: 'LiveVideos'
}
</script>

<style scoped>
.video-item {
  background-color: #ccc;
  border: 1px solid #000000;
  position: relative;
}

.video-item span {
  color: #000000;
  display: block;
  font-weight: bold;
}

.video-item .video-title {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #000000;
  z-index: 9;
  text-shadow: 1px 1px 2px #dee2e6, 0 0 1em #f8f9fa, 0 0 0.2em #dee2e6;
}

.video-item .play-btn {
  background: white;
  display: inline-block;
  padding: 25px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.video-item .play-btn:hover {
  cursor: pointer;
}

.video-item .play-btn:after {
  content: '';
  display: block;
  position: relative;
  left: 2px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 10px 20px;
  border-color: transparent transparent transparent #000000;
}

.video-footer {
  color: #0b0f13;
  display: flex;
  justify-content: space-between;
  font-weight: 300;
}

.video-footer a {
  color: #0b0f13;
  font-weight: bold;
}
</style>
